'use client';

import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

import { themes, useTheme } from '@/contexts/ThemeContext';

export default function Footer() {
  const { currentTheme } = useTheme();

  // const socialLinks = [
  //   {
  //     name: 'Twitter',
  //     href: '#',
  //     icon: Twitter,
  //   },
  //   {
  //     name: 'LinkedIn',
  //     href: '#',
  //     icon: Linkedin,
  //   },
  //   {
  //     name: 'GitHub',
  //     href: '#',
  //     icon: Github,
  //   },
  // ];

  const footerLinks = [
    { name: 'Home', href: '#hero' },
    { name: 'Team', href: '#team' },
    { name: 'Contact', href: '#contact' },
  ];

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId.replace('#', ''));
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer
      className="relative w-full overflow-hidden py-12 sm:py-16"
      style={{ background: themes[currentTheme].bgGradient }}
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="flex flex-col items-center justify-between gap-8 sm:flex-row">
          {/* Logo and tagline */}
          <div className="flex flex-col items-center gap-4 sm:items-start">
            <img
              src="/mittal.png"
              alt="Mittal Ventures"
              className="h-8 w-auto"
              loading="lazy"
            />
            <p
              className="text-sm"
              style={{ color: themes[currentTheme].textMuted }}
            >
              Building the future of technology
            </p>
          </div>

          {/* Navigation */}
          <div className="z-10 flex flex-col items-center gap-4 sm:items-end">
            <div className="flex gap-6">
              {footerLinks.map((link) => (
                <Link
                  key={link.name}
                  to={link.href}
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToSection(link.href);
                  }}
                  className="text-sm transition-colors duration-200 hover:text-opacity-80"
                  style={{ color: themes[currentTheme].text }}
                >
                  {link.name}
                </Link>
              ))}
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div
          className="mt-8 border-t pt-8"
          style={{ borderColor: `${themes[currentTheme].text}20` }}
        >
          <p
            className="text-center text-sm"
            style={{ color: themes[currentTheme].textMuted }}
          >
            © {new Date().getFullYear()} Mittal Ventures. All rights reserved.
          </p>
        </div>
      </div>

      {/* Background gradient circles */}
      <motion.div
        className="absolute right-0 top-0 size-[35vw] max-w-[600px] rounded-full opacity-30 blur-[60px]"
        style={{ background: themes[currentTheme].gradient }}
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 0.3 }}
        transition={{ duration: 1.5 }}
      />
      <motion.div
        className="absolute bottom-0 left-0 size-[30vw] max-w-[500px] rounded-full opacity-20 blur-[50px]"
        style={{ background: themes[currentTheme].gradient }}
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 0.2 }}
        transition={{ duration: 1.5, delay: 0.2 }}
      />
    </footer>
  );
}
